import { render, staticRenderFns } from "./StudentDocumentsView.vue?vue&type=template&id=e1210f3c"
import script from "./StudentDocumentsView.vue?vue&type=script&lang=js"
export * from "./StudentDocumentsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports